import { render, staticRenderFns } from "./recharge_record.vue?vue&type=template&id=66807de2&scoped=true"
import script from "./recharge_record.vue?vue&type=script&lang=ts"
export * from "./recharge_record.vue?vue&type=script&lang=ts"
import style0 from "./recharge_record.vue?vue&type=style&index=0&id=66807de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66807de2",
  null
  
)

export default component.exports